import { useEffect, useState } from "react";

const ROUTES = [
  { name: "create", pattern: /^\/create$/, keys: [] },
  { name: "admin", pattern: /^\/admin$/, keys: [] },
  { name: "process", pattern: /^\/process\/([^/]+)$/, keys: ["processId"] },
];

export const paths = {
  list: () => "/",
  create: () => "/create",
  admin: () => "/admin",
  process: (processId) => `/process/${encodeURIComponent(processId)}`,
};

export function parsePath(path) {
  for (const route of ROUTES) {
    const match = route.pattern.exec(path);
    if (match) {
      const params = {};
      route.keys.forEach((key, index) => {
        params[key] = decodeURIComponent(match[index + 1]);
      });
      return { name: route.name, params };
    }
  }
  return { name: "list", params: {} };
}

function currentPath() {
  return window.location.hash.replace(/^#/, "") || "/";
}

export function href(path) {
  return `#${path}`;
}

export function navigate(path) {
  window.location.hash = path;
}

export function useRoute() {
  const [path, setPath] = useState(currentPath);

  useEffect(() => {
    const onChange = () => setPath(currentPath());
    window.addEventListener("hashchange", onChange);
    return () => window.removeEventListener("hashchange", onChange);
  }, []);

  return parsePath(path);
}
